import Decimal from 'decimal.js';

const REVIEW_RATING_CANONICAL_FRACTION_DIGITS = 2;
const REVIEW_RATING_DISPLAY_FRACTION_DIGITS = 1;

/**
 * Normalizes an average review rating to the value represented by the one-decimal UI.
 *
 * The first step deliberately mirrors the Facade's `Number(value.toFixed(2))` projection.
 * The final display step uses decimal half-up rounding so every client has the same explicit
 * behavior at one-decimal boundaries.
 */
export function normalizeReviewRating(rating: number): number {
  const canonicalRating = Number(rating.toFixed(REVIEW_RATING_CANONICAL_FRACTION_DIGITS));

  return new Decimal(canonicalRating)
    .toDecimalPlaces(REVIEW_RATING_DISPLAY_FRACTION_DIGITS, Decimal.ROUND_HALF_UP)
    .toNumber();
}

/**
 * Formats an average review rating consistently across raw insight and Facade projection paths.
 *
 * Raw insight ratings retain their source precision, while PDP and listing ratings are projected
 * to two decimal places by the Facade. Canonicalizing to the Facade precision first prevents the
 * same source rating from displaying differently depending on which API path supplied it.
 */
export function formatReviewRating(rating: number): string {
  return normalizeReviewRating(rating).toFixed(REVIEW_RATING_DISPLAY_FRACTION_DIGITS);
}
